import React from "react";
import Home from "./components/home/Home";
import { withOktaAuth } from "@okta/okta-react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import DrawerContext from "./context/DrawerContext";
import loader from './assets/Images/loader.gif';

export default withOktaAuth(
  class Authentication extends React.Component {
    static contextType = DrawerContext;

    constructor(props) {
      super(props);
      this.login = this.login.bind(this);
      this.logout = this.logout.bind(this);
      this.state = { migrationNoticeOpen: false };
    }

    componentDidMount() {
      this.showMigrationNoticeAfterLogin();
      this.checkAuthentication();
    }

    componentDidUpdate() {
      this.checkAuthentication();
      this.showMigrationNoticeAfterLogin();
    }

    showMigrationNoticeAfterLogin = () => {
      if (
        this.props.authState?.isAuthenticated &&
        !sessionStorage.getItem("hov_migration_notice_seen")
      ) {
        sessionStorage.setItem("hov_migration_notice_seen", "true");
        this.setState({ migrationNoticeOpen: true });
      }
    }

    checkAuthentication = () => {
      if (this.props.authState?.isAuthenticated) {
        localStorage.setItem(
          "hov_token",
          this.props.authState?.accessToken.accessToken
        );
        localStorage.setItem(
          "hov_access_token",
          JSON.stringify(this.props.authState?.accessToken)
        );
      }
    };

    async login() {
      if (this.props.authState?.isAuthenticated) {
        localStorage.setItem("hov_token",
          this.props.authState?.accessToken.accessToken
        );
        localStorage.setItem(
          "hov_access_token",
          JSON.stringify(this.props.authState?.accessToken)
        );
      } else {
        await this.props.oktaAuth.signInWithRedirect();
      }
    }

    async logout() {
      await this.props.oktaAuth.signOut("/");
    }

    render() {
      const user = this.props.authState?.idToken
      const value = this.context;
      value.setUserInfo(user);
      if (this.props.authState?.isPending) {
        return (
          <div
            style={{
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              src={loader}
              alt="Loading..."
              style={{ height: 200, width: 200 }}
            />
          </div>
        );
      }
      else if (this.props.authState?.isAuthenticated) {
        return (
          <>
            <Home oktaAuth={this.props.oktaAuth} logout={this.logout} />
            <Dialog
              open={this.state.migrationNoticeOpen}
              onClose={() => this.setState({ migrationNoticeOpen: false })}
              aria-labelledby="migration-notice-title"
              aria-describedby="migration-notice-description"
            >
              <DialogTitle id="migration-notice-title">
                Scheduled Migration
              </DialogTitle>
              <DialogContent id="migration-notice-description">
                A scheduled system migration is in progress. The portal is
                temporarily read-only: you can view information, but changes
                cannot be made until the migration is complete.
                <p style={{ margin: "16px 0 0" }}>
                  For the new portal experience, visit{" "}
                  <a href="https://nexus.hov.verisk.com/" target="_blank" rel="noreferrer">
                    HOV Nexus Portal
                  </a>.
                </p>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => this.setState({ migrationNoticeOpen: false })} autoFocus>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        );
      }
      else {
        this.login();
        return (
          <div
            style={{
              height: '100vh',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img
              src={loader}
              alt="Loading..."
              style={{ height: 200, width: 200 }}
            />
          </div>
        );
      }
    }
  }
);